export default __webpack_public_path__ + "hard-drive.png";